import { Icon } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Input from "../../components/Input";
import AlertModal from "../../components/Modal";
import StatusAlert from "../../components/StatusAlert";
import TransactionDetailsStatus from "../../components/TransactionDetailsStatus";
import { getCurrency, getDateTime } from "../../helpers/Functions";
import { Reducers } from "../../Interfaces/Interfaces";
import { AddComplaint, jiraRequestLogDetails } from "../../redux/actions/JiraActions";
import {
    reconfirmTransactions,
} from "../../redux/actions/TransactionActions";
import { getAggregatorDashboard } from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";

export default function LogsDetails() {

    const alert = useSelector((state: Reducers) => state.alert);
    const logs = useSelector(
        (state: Reducers) => state.logsDetails
    );
    const user = useSelector((state: Reducers) => state.user);
    const transactionsDetailsStatus = useSelector(
        (state: Reducers) => state.transactionDetailsStatusReducer
    );
    // const dashboard: any = useSelector((state: Reducers) => state.dashboard);
    const history = useHistory();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const params: any = useParams();
    const [submitted, setSubmitted] = React.useState(false);
    const [confirm, setConfirm] = React.useState(false);
    const [comment, setComment] = React.useState("");
    const [transactionTypeChoose, settransactionTypeChoose] = React.useState("")
    const [successStatus, setsuccessStatus] = React.useState(false)
    const handleRefresh = () => {
        dispatch({
            type: "LOADING",
            payload: true,
        });
        dispatch(jiraRequestLogDetails(params.id));
    };

    const reconfirm = (ref: string, transactionType: string) => {

        settransactionTypeChoose(transactionType)
        setSubmitted(true);
        dispatch({
            type: 'ALERT',
            payload: {}
        });
        const data = {
            ref,
            transactionType
        }
        dispatch(reconfirmTransactions(data));

        dispatch({
            type: "LOADING",
            payload: true,
        });
    };
    // React.useEffect(() => {
    //     if (Object.entries(alert).length !== 0) {
    //         if (!alert.successful) {
    //             // display error message
    //             enqueueSnackbar(alert.message, { variant: "error" });

    //             dispatch({
    //                 type: "LOADING",
    //                 payload: false,
    //             });

    //             dispatch({
    //                 type: "ALERT",
    //                 payload: {},
    //             });

    //             setSubmitted(false);
    //         } else {
    //             setSubmitted(false);
    //             setComment("");
    //             handleRefresh();

    //             if (alert.message === "Complaint logged successfully") {
    //                 dispatch({
    //                     type: "STATUS_ALERT",
    //                     payload: true,
    //                 });
    //             }

    //             if (alert.message === "Success") {
    //                 enqueueSnackbar(alert.message, { variant: "success" });
    //             }

    //             dispatch({
    //                 type: "LOADING",
    //                 payload: false,
    //             });

    //             dispatch({
    //                 type: "ALERT",
    //                 payload: {},
    //             });
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [dispatch, enqueueSnackbar, alert, history]);
    const reconfirmStatus = (ref: string) => {

        console.log({ "ref": ref })
        if (ref !== null) {
            dispatch(reconfirmTransactions(ref));
            dispatch({
                type: "LOADING",
                payload: true,
            });
        }


    };


    const handleSubmit = () => {
        const data = {
            // reference: logs.reference,
            transactionId: logs.id,
            comment,
            channel: 1,
            // fileUploadUrl: string
        };

        dispatch(AddComplaint(data));
        setSubmitted(true);
    };

    React.useEffect(() => {
        dispatch({
            type: "LOADING",
            payload: true,
        });

        dispatch(jiraRequestLogDetails(params.id));
        dispatch(getAggregatorDashboard());

        return () => {
            dispatch({
                type: "LOGS_DETAILS",
                payload: {},
            });
            dispatch({
                type: "DASHBOARD",
                payload: {},
            });
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    React.useEffect(() => {
        if (Object.entries(alert).length !== 0) {
            if (!alert.successful) {
                // display error message
                setsuccessStatus(false)
                enqueueSnackbar(alert.message, { variant: "error" });

                dispatch({
                    type: "LOADING",
                    payload: false,
                });

                dispatch({
                    type: "ALERT",
                    payload: {},
                });

                setSubmitted(false);
            } else {
                setsuccessStatus(true)
                setSubmitted(false);
                setComment("");
                handleRefresh();

                if (alert.message === "Complaint logged successfully") {
                    dispatch({
                        type: "STATUS_ALERT",
                        payload: true,
                    });
                }

                if (alert.message === "Successful") {
                    enqueueSnackbar("Success", { variant: "success" });
                }

                dispatch({
                    type: "LOADING",
                    payload: false,
                });

                dispatch({
                    type: "ALERT",
                    payload: {},
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, enqueueSnackbar, alert, history]);

    return (
        <React.Fragment >
            <div >
                <div
                    className="col-md-11 mr-auto ml-auto p-0"
                    style={{
                        height: "auto",
                        position: "relative",

                    }}
                >
                    <DenseAppBar onClick={() => history.goBack()} canGoBack />
                </div>
                <div
                    className="col-md-12 pl-0 pr-0"
                    style={{

                        // overflow: "auto",
                        backgroundColor: PrimaryTheme.white,
                        // height: '100vh',
                    }}
                >
                    <div
                        className="col-md-11 ml-auto mr-auto p-0 mb-1"
                        style={{

                            backgroundColor: PrimaryTheme.white,
                            height: "100vh",
                            position: "relative",
                        }}
                    >
                        <h1
                            className="mb-5 log-title   "
                            style={{
                                fontFamily: PrimaryTheme.fonts?.MediumFont,
                                textTransform: "uppercase",
                                fontSize: PrimaryTheme.fontSizes?.subtitle,
                            }}
                        >
                            LOGS Details
                        </h1>

                        <div className="col-md-12 p-0  mt-5" >
                            <div className="row log-title">
                                <div className="col-md-6 mb-2 ">
                                    <h6
                                        className="text-left "
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.primary,
                                            textTransform: "uppercase",
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        LOGGED ID
                                    </h6>
                                    <h4 className="text-left mb-5">
                                        {logs.logId ? logs.logId : "-"}
                                    </h4>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <h6
                                        className="text-center"
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.primary,
                                            textTransform: "uppercase",
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        Amount
                                    </h6>
                                    <h4 className="text-center mb-2">
                                        {logs.amount ? getCurrency(logs.amount) : "-"}
                                    </h4>
                                </div>

                            </div>

                            <div className="row" style={{ paddingLeft: "20px" }}>
                                <div className="col-md-8 mb-2">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.primary,
                                            textTransform: "uppercase",
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        Reference
                                    </h5>

                                    <p>{logs.reference ? logs.reference : "-"}</p>
                                </div>
                                <div className="col-md-4 mb-2">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.primary,
                                            textTransform: "uppercase",
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        TYPE
                                    </h5>

                                    <p>{logs.reference ? logs.reference : "-"}</p>
                                </div>

                            </div>




                            <div className="row" style={{ paddingBottom: "150px", background: "white", paddingLeft: "20px" }}>


                                <div className="col-md-4 mb-3 ">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            textTransform: "uppercase",
                                            color: PrimaryTheme.primary,
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        SENDER
                                    </h5>

                                    <p>
                                        {logs.agentName
                                            ? logs.agentName
                                            : "-"}

                                        <span
                                            style={{
                                                color: PrimaryTheme.light,
                                                display: "block"
                                            }}
                                        >
                                            ({logs.agentPhoneNumber ? logs.agentPhoneNumber : "-"})
                                        </span>
                                    </p>

                                </div>

                                <div className="col-md-4">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            textTransform: "uppercase",
                                            color: PrimaryTheme.primary,
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        CHANNEL
                                    </h5>

                                    <p>{logs.channelName ? logs.channelName : "-"}</p>
                                </div>

                                <div className="col-md-4 mb-3 ">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            textTransform: "uppercase",
                                            color: PrimaryTheme.primary,
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        STATUS
                                    </h5>

                                    <p className="mb-0 pb-0">
                                        {logs.jiraStatus ? logs.jiraStatus : "-"}
                                    </p>

                                </div>

                                <div className="col-md-4 fs-6">
                                    <h5
                                        className="fs-6"
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.primary,
                                            textTransform: "uppercase",
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        RECEIVER
                                    </h5>

                                    <p>{logs.aggregatorName ? logs.aggregatorName : "-"}

                                        <span
                                            style={{
                                                color: PrimaryTheme.light,
                                                display: "block"
                                            }}
                                        >
                                            ({logs.aggregatorPhoneNumber ? logs.aggregatorPhoneNumber : "-"})
                                        </span>
                                    </p>
                                </div>

                                <div className="col-md-4 mb-3 ">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            textTransform: "uppercase",
                                            color: PrimaryTheme.primary,
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        DATE
                                    </h5>

                                    <p>
                                        {logs.dateCreated ? getDateTime(logs.dateCreated) : "-"}
                                    </p>
                                </div>

                                <div className="col-md-4">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.primary,
                                            textTransform: "uppercase",
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        BALANCE BEFORE
                                    </h5>

                                    <p>
                                        {logs.transactionDate
                                            ? getDateTime(logs.transactionDate)
                                            : "-"}
                                    </p>
                                </div>

                                <div className="col-md-4 mb-3 ">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            textTransform: "uppercase",
                                            color: PrimaryTheme.primary,
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        DESCRIPTION
                                    </h5>

                                    <p>
                                        {logs.description ? logs.description : "-"}
                                    </p>
                                </div>

                                <div className="col-md-4">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.primary,
                                            textTransform: "uppercase",
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        CHARGE
                                    </h5>

                                    <p>
                                        {logs.charges
                                            ? getCurrency(logs.charges)
                                            : "-"}
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <h5
                                        style={{
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.primary,
                                            textTransform: "uppercase",
                                            fontSize: PrimaryTheme.fontSizes?.normal,
                                        }}
                                    >
                                        BALANCE AFTER
                                    </h5>

                                    <p>
                                        {logs.charges
                                            ? getCurrency(logs.charges)
                                            : "-"}
                                    </p>
                                </div>
                            </div>

                            <div className="col-md-5 ml-auto mr-auto mt-3 text-center">
                                {
                                    logs.requestTypeName === "Bill Payment" || logs.requestTypeName === "Transfer" ? <Input
                                        onClick={() => reconfirm(logs.reference, logs.requestTypeName)}
                                        // onClick={() => reconfirm(logs.parentReference)}

                                        type="button"
                                        isInput
                                        disabled={submitted}
                                        value={submitted ? "Confirming..." : "Reconfirm Transaction"}
                                        style={{
                                            background: PrimaryTheme.warn,
                                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                                            color: PrimaryTheme.dark,
                                            paddingLeft: "3rem",
                                            paddingRight: "3rem",
                                        }}
                                        className="text-bold border-0"
                                    /> : ""
                                }


                                {/* <button
                                className="btn btn-link text-secondary"
                                onClick={() => dispatch({ type: "ALERT_MODAL", payload: true })}
                            >
                                <div className="row m-0 align-items-center" style={{
                                    color: PrimaryTheme.light,
                                }}>
                                    <Icon
                                        style={{
                                            marginRight: 5,

                                        }}
                                    >
                                        download
                                    </Icon>{" "}
                                    DOWNLOAD RECEIPT
                                </div>
                            </button> */}
                            </div>
                            {/*start of transaction status div */}
                            {
                                successStatus ?
                                    transactionTypeChoose !== "" ? Object.entries(transactionsDetailsStatus).length === 0 ? "" : <TransactionDetailsStatus transactionTypeChoose={transactionTypeChoose} /> : "" : ""

                            }


                            {/* End of transaction status div */}
                        </div>
                    </div>
                </div>
                <AlertModal>
                    <div className="col-md-12 p-5 text-center">
                        <div className="col-md-12">
                            <span
                                className="badge-pill p-3 d-block col-7 ml-auto mr-auto"
                                style={{
                                    background: PrimaryTheme.warn,
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                }}
                            >
                                Hello! What’s the issue
                            </span>
                        </div>

                        <p
                            className="mt-3 mb-5"
                            style={{
                                fontFamily: PrimaryTheme.fonts?.RegularFont,
                                fontSize: 18,
                                color: PrimaryTheme.light,
                            }}
                        >
                            This transaction details have been captured. Briefly describe the
                            challenge you’re facing.
                        </p>

                        <div className="form-group mt-5 mb-0">
                            <Input
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                disabled={submitted}
                                style={{
                                    background: "#F4F7FC",
                                    fontFamily: PrimaryTheme.fonts?.RegularFont,
                                    color: PrimaryTheme.dark,
                                    height: 200,
                                }}
                                className="text-bold border-0 col-md-12"
                            />
                        </div>

                        <div className="form-group mt-5 mb-0">
                            <Input
                                onClick={handleSubmit}
                                type="button"
                                isInput
                                value={submitted ? "Escalating..." : "Escalate To Bankly"}
                                disabled={comment.length === 0 || submitted}
                                style={{
                                    background: PrimaryTheme.primary,
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.white,
                                }}
                                className="text-bold border-0 col-md-6"
                            />
                        </div>
                    </div>
                </AlertModal>

                <StatusAlert
                    subtitle="The support team will attend to this complaint shortly."
                    title={"Escalated To Bankly"}
                    buttonTitle="Back to logs"
                    onClick={() => history.push("/logs")}
                ></StatusAlert>
            </div>
            {
                (confirm) ?
                    <div


                        className="shadow p-3 mb-5 bg-white rounded col-md-8 ml-auto mr-auto p-0 mb-5">
                        <div className="col-md-9 ml-auto mr-auto">
                            <h6
                                className="text-center"
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.dark,
                                    textTransform: "uppercase",
                                }}
                            >
                                SYSTEM TRANSACTION DETAILS
                            </h6>

                            <p
                                className="text-center mb-1"
                                style={{
                                    fontSize: PrimaryTheme.fontSizes?.small,
                                    color: PrimaryTheme.light,
                                }}
                            >
                                The details below show the final transaction status known to Bankly
                                from our partners
                            </p>

                            <div className="col-md-9 mb-1 ml-auto mr-auto">
                                <div
                                    className="progress w-100"
                                    style={{
                                        height: "10px",
                                    }}
                                >
                                    <div
                                        className="progress-bar "
                                        role="progressbar"
                                        style={{ width: "100%", backgroundColor: "#296cf0" }}
                                    >
                                        <span className="sr-only">70% Complete</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 mt-3 mb-3 ml-auto mr-auto">
                                <div className="d-flex justify-content-between">
                                    <span
                                        className=""
                                        style={{
                                            fontSize: PrimaryTheme.fontSizes?.small,
                                            color: PrimaryTheme.light,
                                            width: "90px",
                                            height: "23px",
                                            paddingRight: "35px",
                                            paddingLeft: "30px",
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                        }}
                                    >
                                        STATUS
                                    </span>{" "}
                                    <span
                                        className="badge rounded-pill bg-danger p-2"
                                        style={{
                                            width: "110px",
                                            color: "white",
                                            paddingRight: "35px",
                                            paddingLeft: "35px",
                                        }}
                                    >
                                        {logs.statusName ? logs.statusName : "-"}
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-3" style={{
                                color: PrimaryTheme.light,
                            }}>
                                <div
                                    className="col-md-9 ml-auto mr-auto mb-3"
                                    style={{
                                        width: "915px",
                                        height: "auto",


                                        borderRadius: "4px",
                                        backgroundColor: "rgb(244, 247, 252)",
                                    }}
                                >
                                    <div className=" d-flex justify-content-around pt-2 pb-2">




                                        <div className="col-6"
                                            style={{
                                                textAlign: "right"
                                            }}


                                        >RESPONSE CODE</div>
                                        <div className="col-6">91</div>


                                        {/* <span></span> <span className="">RESPONSE CODE</span>
                     <span className="">91</span> <span></span> */}
                                    </div>
                                </div>

                                <div
                                    className="col-md-9 ml-auto mr-auto"
                                    style={{
                                        width: "915px",
                                        height: "41px",
                                        borderRadius: "4px",
                                    }}
                                >
                                    <div className="  d-flex justify-content-around pt-2 pb-2">

                                        <div className="row">


                                            <div className="col-6"
                                                style={{
                                                    textAlign: "right"
                                                }}


                                            >NIBBSS SESSION ID</div>
                                            <div className="col-6">009083746650908374665</div>

                                        </div>

                                        {/* <span></span>
                     <span className="text-center">NIBBSS reference SESSION ID</span>
                     <span className="text-center">009083746650908374665</span> <span></span> */}
                                    </div>
                                </div>
                                <div
                                    className="col-md-9 ml-auto mr-auto mb-3"
                                    style={{
                                        width: "915px",
                                        height: "auto",


                                        borderRadius: "4px",
                                        backgroundColor: "rgb(244, 247, 252)",
                                    }}
                                >
                                    <div className=" d-flex justify-content-around pt-2 pb-2">




                                        <div className="col-6"
                                            style={{
                                                textAlign: "right"
                                            }}

                                        >REFERENCE</div>
                                        <div className="col-6">  {logs.reference ? logs.reference : "-"}</div>


                                        {/* <span></span> transactionDate<span className="">RESPONSE CODE</span>
                     <span className="">91</span> <span></span> */}
                                    </div>
                                </div>

                                <div
                                    className="col-md-9 ml-auto mr-auto"
                                    style={{
                                        width: "915px",
                                        height: "41px",
                                        borderRadius: "4px",
                                    }}
                                >
                                    <div className="   pt-2 pb-2">

                                        <div className="row">


                                            <div className="col-6" style={{
                                                textAlign: "right"
                                            }}>TIME</div>
                                            <div className="col-6"> {logs.transactionDate
                                                ? getDateTime(logs.transactionDate)
                                                : "-"}</div>

                                        </div>

                                        {/* <span></span>
                     <span className="text-center">NIBBSS SESSION ID</span>
                     <span className="text-center">009083746650908374665</span> <span></span> */}
                                    </div>
                                </div>


                                <div
                                    className="col-md-9 ml-auto mr-auto mb-3"
                                    style={{
                                        width: "915px",
                                        height: "auto",


                                        borderRadius: "4px",
                                        backgroundColor: "rgb(244, 247, 252)",
                                    }}
                                >
                                    <div className=" d-flex justify-content-around pt-2 pb-2">




                                        <div className="col-6"
                                            style={{
                                                textAlign: "right"
                                            }}

                                        >AMOUNT</div>
                                        <div className="col-6">{logs.amount ? getCurrency(logs.amount) : "-"}</div>


                                        {/* <span></span> statusName <span className="">RESPONSE CODE</span>
                     <span className="">91</span> <span></span> */}
                                    </div>
                                </div>



                            </div>
                            <h6
                                className="text-center"
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.dark,
                                    textTransform: "uppercase",
                                }}
                            >
                                BANKLY FEEDBACK
                            </h6>
                            <p
                                className="text-center ml-5 mr-5 mb-3"
                                style={{
                                    fontSize: PrimaryTheme.fontSizes?.small,
                                    color: PrimaryTheme.light,
                                }}
                            >
                                This transaction failed and the agent wallet was not debited.
                                Agent should confirm reversal to wallet & initiate the transaction again
                            </p>



                            <div className="col-md-5 ml-auto mr-auto mt-3 text-center">
                                <Input
                                    // onClick={() => reconfirm(logs.parentReference)}
                                    type="button"
                                    isInput
                                    disabled={submitted}
                                    value={submitted ? "Confirming..." : "Resolve Complaint"}
                                    style={{
                                        background: PrimaryTheme.primary,
                                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                                        color: PrimaryTheme.white,

                                    }}
                                    className="text-bold border-0"
                                />

                                {/* <button
                                    className="btn btn-link text-secondary"
                                    onClick={() => dispatch({ type: "ALERT_MODAL", payload: true })}
                                >
                                    <div className="row m-0 align-items-center">
                                        <Icon
                                            style={{
                                                marginRight: 5,
                                                transform: "rotate(-45deg) scaleX(-1)",
                                            }}
                                        >
                                            reply_all
                       </Icon>{" "}
                       Escalate to Bankly
                     </div>
                                </button> */}
                            </div>
                        </div>
                    </div> : null

            }

        </React.Fragment>
    );
}
